import { render, staticRenderFns } from "./FoodItem.vue?vue&type=template&id=1ae3a276&scoped=true"
import script from "./FoodItem.vue?vue&type=script&lang=js"
export * from "./FoodItem.vue?vue&type=script&lang=js"
import style0 from "./FoodItem.vue?vue&type=style&index=0&id=1ae3a276&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae3a276",
  null
  
)

export default component.exports